import {SNACKBAR_ACTIONS} from "../actions/types";
import {COLOR_ALERT} from "../misc/vars";
const defaultState = {
	message: null,
	color: null
};
const _color = (type) => {
	switch (type) {
		case 'alert':
			return COLOR_ALERT;
		default:
			return 'black';
	}
};
export default (state = defaultState, {type, message, color}) => {
	switch (type) {
		case SNACKBAR_ACTIONS.SET:
			return {
				message,
				color: _color(color)
			};
		case SNACKBAR_ACTIONS.UNSET:
			return defaultState;
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/snackbarReducer.js